import type { AppointmentResultReportCondition } from '@/api/types/ProviderApi'
import { Header } from '@/ui/core/header'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'
import { View } from 'react-native'

const ResultCondition = ({
	condition,
}: { condition: AppointmentResultReportCondition }) => (
	<VStack
		className="justify-center max-w-[20rem] px-6 py-5 bg-palette_5 rounded-lg mb-6"
		key={condition.title}
	>
		<View className="self-start">
			<Header variant="h4" className="mb-4">
				{condition.title}
			</Header>
		</View>
		<Text className="text-balance text-palette_6">{condition.description}</Text>
	</VStack>
)

const ResultConditionsList = ({
	conditions = [],
}: { conditions?: AppointmentResultReportCondition[] }) => {
	return (
		<VStack className="items-center justify-center self-center">
			<View>
				{conditions.map((condition) => (
					<ResultCondition key={condition.title} condition={condition} />
				))}
			</View>
		</VStack>
	)
}

export { ResultConditionsList }
